import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import Layout from "../../components/global/layout";
import RequestQuoteListing from "../Quote/RequestQuoteListing";
import QuickBookEstimateList from "../QuickBooks/QuickBookEstimate";
import QuickBookInvoiceList from "../QuickBooks/InvoiceList";
import OrderTrackingList from "../OrderTracking/OrderTrackingList";
import methodModel from "../../methods/methods";

export default function OrderMgmt() {
  const user = useSelector((state) => state.user);
  const history = useNavigate();
  const [searchParams] = useSearchParams();
  const isConnected = !!user?.quick_book_accesToken;
  const currentTab = searchParams.get("tab");
  const metaId = searchParams.get("id");
  const subTab = searchParams.get("subTab");
  const [selectedTab, setSelectedTab] = useState(currentTab || "request_quote");

  useEffect(() => {
    if (currentTab) {
      setSelectedTab(currentTab);
    }
  }, [currentTab]);

  if (!isConnected) {
    return (
      <Layout>
        <div className="max-xl:container xl:max-w-[1280px]  mx-auto">
          <div className="flex flex-col gap-1 mb-6">
            <h2 className="text-gray-900 text-xl sm:text-2xl font-semibold">
              Order Management
            </h2>
            <p className="text-sm sm:text-md text-gray-600">Manage your Order</p>
          </div>
          <div className="w-full border rounded-2xl bg-white p-5 lg:p-8">
            <div className="flex flex-col items-center justify-center py-20 gap-6 text-center">
              <div className="size-20 rounded-2xl bg-[#2CA01C]/10 border border-[#2CA01C]/20 flex items-center justify-center">
                <svg
                  viewBox="0 0 40 40"
                  width="40"
                  height="40"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="18"
                    cy="18"
                    r="10"
                    fill="none"
                    stroke="#2CA01C"
                    strokeWidth="3"
                  />
                  <line
                    x1="25"
                    y1="25"
                    x2="31"
                    y2="31"
                    stroke="#2CA01C"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div className="space-y-1.5">
                <h3 className="text-lg font-semibold text-gray-900">
                  QuickBooks Not Connected
                </h3>
                <p className="text-sm text-gray-500 max-w-sm">
                  Connect your QuickBooks account to view and manage your order.
                </p>
              </div>
              <button
                type="button"
                onClick={() => history("/quickbook/integration")}
                className="w-fit inline-flex items-center gap-2 bg-[#115B9D] hover:opacity-80 text-white text-sm rounded-xl transition-colors font-medium px-5 py-2.5"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                </svg>
                Connect QuickBooks
              </button>
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  const AllTabs = [
    { name: "Request To Quote", id: "request_quote" },
    { name: "Estimate", id: "estimate" },
    { name: "Invoice", id: "invoice" },
    { name: "Order Tracking", id: "order_tracking" },
  ];

  return (
    <Layout>
      <div className="max-xl:container xl:max-w-[1280px]  mx-auto">
        <div className="flex flex-wrap items-center justify-between gap-2 mb-6">
          <div className="flex flex-col gap-1">
            <h2 className="text-gray-900 text-xl sm:text-2xl font-semibold">
              Order Management
            </h2>
          </div>
          {selectedTab === "estimate" ? (
            <></>
          ) : selectedTab === "invoice" ? (
            <></>
          ) : (
            ""
          )}
        </div>

        <div className="w-full md:w-fit overflow-auto flex items-center gap-1 bg-gray-100 rounded-xl max-lg:[scrollbar-width:none] max-lg:[-ms-overflow-style:none] max-lg:[&::-webkit-scrollbar]:hidden p-1.5 mb-3">
          {AllTabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setSelectedTab(tab.id)}
              className={`whitespace-nowrap px-4 py-1.5 rounded-lg text-sm font-medium transition-all ${selectedTab === tab.id
                  ? "bg-white text-gray-900 shadow-sm"
                  : "text-gray-600 hover:text-gray-700"
                }`}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {selectedTab === "request_quote" ? (
          <RequestQuoteListing metaId={currentTab === "request_quote" ? metaId : null} />
        ) : selectedTab === "estimate" ? (
          <QuickBookEstimateList metaId={currentTab === "estimate" ? metaId : null} subTab={subTab} />
        ) : selectedTab === "order_tracking" ? (
          <OrderTrackingList />
        ) : (
          <QuickBookInvoiceList metaId={currentTab === "invoice" ? metaId : null} />
        )}
      </div>
    </Layout>
  );
}
